import { decodeJwt } from "jose";
import { AuthActionTypes } from "./auth-types";

const User = ({ userId, email, name, orgId, orgName }) =>
    ({ userId, email, name, orgId, orgName });

const initialState = {};

const authReducer = (state = initialState, action) => {
    switch(action.type) {
        case AuthActionTypes.setJWT:
            return {
                ...state,
                ...User(decodeJwt(action.payload)),
            }
        default:
            return state;
    }
}

export default authReducer;